export const checkIfAllowedToEnableOrRemoveExtension = (data: any) => {
  const isSuccess = data?.isAllowedToEnableAndRemoveExtension.success
  const hasAccess = data?.isAllowedToEnableAndRemoveExtension.access
  if (isSuccess === false) {
    // rare case: allow user to enable extension if TCPS returns error
    console.error(
      "Error: failed to determine if user has access to enable extension",
      data?.isAllowedToEnableAndRemoveExtension.message
    )
  } else if (isSuccess === true && !hasAccess) {
    // Show modal with a message
    console.warn("User does not have access to activate/remove QuadriProject by policy")
    return false
  } else {
    console.log("User has access to activate/remove QuadriProject by policy")
  }
  return true
}

export const checkIfAllowedToEnableInProjectRegion = (result: any, projectRegion: string) => {
  const isSuccess = result.success
  const regions = result.regions
  const restricted = result.restricted
  if (isSuccess === false) {
    // rare case: allow user to enable extension if TCPS returns error
    console.error("Error: failed to determine if user has access to enable extension", result.message)
  } else if (
    isSuccess === true &&
    restricted === true &&
    !regions.toLowerCase().includes(projectRegion.toLowerCase())
  ) {
    console.warn("User does not have access to enable QuadriProject by region policy")
    return false
  } else {
    console.log("User has access to enable QuadriProject by region policy")
  }
  return true
}

export const getDisplayNamesForRegions = (
  regions: string,
  regionsDisplayNames: { name: string; displayName: string }[]
) => {
  if (!regions) {
    return ""
  }
  // Convert region list to lowercase and split into an array
  const formattedRegions = regions
    .toLowerCase()
    .split(", ")
    .map((regionName: string) => regionName.trim())

  // Create a lookup map for easier conversion
  const regionMap = regionsDisplayNames.reduce((map: { [key: string]: string }, region) => {
    map[region.name.toLowerCase()] = region.displayName
    return map
  }, {})

  // Map input regions to display names using the lookup map, then join to form a comma-separated string
  return formattedRegions.map((region) => regionMap[region] || region).join(", ")
}
